import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  UpdateMonitor,
  createMonitor,
  deleteMonitor,
  getMonitor,
  updateMonitorStatus,
} from "../services/uptimeRobotService";

const initialState = {
  isError: false,
  isLoading: false,
  record: [],
  message: "",
};
const getErrorMessage = (error) => {
  return (
    error?.response?.data?.error ||
    (error?.response?.data?.debugInfo && [error?.response?.data?.debugInfo]) ||
    error?.response?.data?.message ||
    error?.response?.data ||
    error.toString()
  );
};
// Get Users Roles
export const get_monitors = createAsyncThunk(
  "get_monitors",
  async (thunkAPI) => {
    try {
      return await getMonitor();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Create New Roles
export const create_monitor = createAsyncThunk(
  "create_monitor",
  async (data, thunkAPI) => {
    try {
      return await createMonitor(data);
    } catch (error) {
      const message = getErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update Roles
export const update_monitor = createAsyncThunk(
  "update_monitor",
  async (data, thunkAPI) => {
    try {
      return await UpdateMonitor(data);
    } catch (error) {
      const message = getErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const delete_monitor = createAsyncThunk(
  "delete_monitor",
  async (data, thunkAPI) => {
    try {
      return await deleteMonitor(data);
    } catch (error) {
      const message = getErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const update_status = createAsyncThunk(
  "update_status",
  async (data, thunkAPI) => {
    try {
      return await updateMonitorStatus(data);
    } catch (error) {
      const message = getErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const uptimeRobotSlice = createSlice({
  name: "uptimeRobots",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.record = [];
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_monitors.pending, (state) => {
        state.isLoading = true;
        state.record = [];
      })
      .addCase(get_monitors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload?.data;
      })
      .addCase(get_monitors.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.record = [];
      })
      .addCase(create_monitor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(create_monitor.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(create_monitor.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(update_monitor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(update_monitor.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(update_monitor.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(delete_monitor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(delete_monitor.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(delete_monitor.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(update_status.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(update_status.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(update_status.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { reset } = uptimeRobotSlice.actions;
export default uptimeRobotSlice.reducer;
